import { render, staticRenderFns } from "./EventPerdatinEdit.vue?vue&type=template&id=5bcc669c&scoped=true"
import script from "./EventPerdatinEdit.vue?vue&type=script&lang=js"
export * from "./EventPerdatinEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcc669c",
  null
  
)

export default component.exports